import type { AllRouteEndpoints } from "../routeTypes";
export const appsConnectedContentCredentialDeleteCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/connected_content_credentials",
];
